export default "/images/vendor/@coreui/icons/svg/flag/cif-gb.svg?5f2bcb46073d4e9de687800a586ccb52";